import loaderGif from "../assets/images/loader/250x250.gif";

const Loading = ({inModal}) => {
    return (
        <div className={`loading ${inModal ? "inModal" : ""}`}>
            <img src={loaderGif} alt="loader"/>
        </div>
    );
};

export default Loading;
